export default __webpack_public_path__ + "static/media/logoblack.7ebf0975.svg";